import React from 'react'
import styled from 'styled-components'
import { sizes } from '../utils/breakpoints'
import { useMediaQuery } from 'react-responsive'

const InfoCardComponent = ({
  info,
  infoBold,
  photo,
  photoAlt,
  panel,
  isLeft,
  isRight,
  max,
}) => {
  const isMobile = useMediaQuery({ maxWidth: sizes.mobile })

  const media = panel || <img src={photo} alt={photoAlt || ''} />

  return (
    <>
      {isMobile ? (
        <ContainerMobile>
          <PhotoMobile>{media}</PhotoMobile>
          <ContainerInfo>
            <Info max={max}>{info}</Info>
            {infoBold && <InfoBold max={max}>{infoBold}</InfoBold>}
          </ContainerInfo>
        </ContainerMobile>
      ) : (
        <Container>
          {isLeft && <Photo isLeft={isLeft}>{media}</Photo>}
          <ContainerInfo isLeft={isLeft}>
            <Info isLeft={isLeft} max={max}>
              {info}
            </Info>
            {infoBold && (
              <InfoBold isLeft={isLeft} max={max}>
                {infoBold}
              </InfoBold>
            )}
          </ContainerInfo>
          {isRight && <Photo isRight={isRight}>{media}</Photo>}
        </Container>
      )}
    </>
  )
}

export default InfoCardComponent

const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.background.card};
  width: 100%;
  max-width: 1140px;
  min-height: 320px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 32px;
  box-shadow: ${({ theme }) => theme.shadows.card};
  border-radius: 16px;
  overflow: hidden;
  box-sizing: border-box;
`

const Photo = styled.div`
  display: flex;
  flex: 0 0 44%;
  overflow: hidden;

  img,
  > div {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

const ContainerInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 48px 56px;
  align-items: ${(props) => props.isLeft && 'end'};

  @media (max-width: ${sizes.mobile}px) {
    padding: 0px;
    margin-bottom: 0px;
    margin-top: 15px;
  }
`

const Info = styled.p`
  max-width: ${(props) => props.max};
  font-size: 16px;
  line-height: 1.6;
  color: ${({ theme }) => theme.colors.text.primary};
  font-family: ${({ theme }) => theme.fonts.accentRegular};
  text-align: ${(props) => props.isLeft && 'right'};

  @media (max-width: ${sizes.mobile}px) {
    font-size: 12px;
    line-height: 14.63px;
    max-width: 500px;
    text-align: center;
  }
`

const InfoBold = styled(Info)`
  font-family: ${({ theme }) => theme.fonts.accentSemi};
`

const ContainerMobile = styled.div`
  width: 100%;
  box-sizing: border-box;
  height: auto;
  padding: 16px;
  gap: 10px;
  border-radius: 10px;
  background: ${({ theme }) => theme.colors.background.card};
  box-shadow: ${({ theme }) => theme.shadows.card};
  margin-bottom: 20px;
`

const PhotoMobile = styled.div`
  width: 100%;
  height: 220px;
  border-radius: 10px;
  overflow: hidden;

  img,
  > div {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 10px;
  }
`
